export const sq6m = {
  'images': [],
  'mainFeatures': [
    'Premium Nature Rubber with Nano Graphite Coating',
    'Patented Multi-function Base and Adapters',
    'Aerodynamic spoiler for high-speed stability'
  ],
  'material': [
    'Rubber: Premium Nature Rubber',
    'Steel: SK6',
    'End Cap: PP',
    'Spoiler: PP+TPE'
  ],
  'featureIcons': ["12", "07", "02", "03"],
  'otherFeatures': ["01", "02"],
  'specification': [
    { "inch": "13", "mm": "330", "width": "6", "thickness": "0.8" },
    { "inch": "14", "mm": "350", "width": "6", "thickness": "0.8" },
    { "inch": "15", "mm": "380", "width": "6", "thickness": "0.8" },
    { "inch": "16", "mm": "400", "width": "6", "thickness": "0.8" },
    { "inch": "17", "mm": "430", "width": "6", "thickness": "0.8" },
    { "inch": "18", "mm": "450", "width": "6", "thickness": "0.8" },
    { "inch": "19", "mm": "480", "width": "6", "thickness": "0.8" },
    { "inch": "20", "mm": "500", "width": "6", "thickness": "0.9" },
    { "inch": "21", "mm": "530", "width": "6", "thickness": "0.9" },
    { "inch": "22", "mm": "560", "width": "6", "thickness": "0.9" },
    { "inch": "23", "mm": "580", "width": "6", "thickness": "0.9" },
    { "inch": "24", "mm": "600", "width": "6", "thickness": "1" },
    { "inch": "25", "mm": "630", "width": "6", "thickness": "1" },
    { "inch": "26", "mm": "650", "width": "6", "thickness": "1" },
    { "inch": "27", "mm": "680", "width": "6", "thickness": "1" },
    { "inch": "28", "mm": "700", "width": "6", "thickness": "1" }
  ],
  'adapters': [
    'c0', 'c1-2', 'c2', 'c3', 'c4', 'c5', 'c6', 'c7', 'c9', 'c10', 'e1'
  ]
}